import './chunk-1fafdf15.js';
import './helpers.js';
import './chunk-6985c8ce.js';
import './chunk-d0a313ea.js';
import './chunk-cdfca85b.js';
import { r as registerComponent, u as use } from './chunk-cca88db8.js';
import { I as Input } from './chunk-d1591eb8.js';
export { I as BInput } from './chunk-d1591eb8.js';

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, Input);
  }
};
use(Plugin);

export default Plugin;



//////////////////
// WEBPACK FOOTER
// ./~/buefy/dist/esm/input.js
// module id = 58
// module chunks = 10